// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/services/misc.ts\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/services/misc.ts");
  import.meta.hot.lastModified = "1793726943423.7498";
}
// REMIX HMR END

import { useOutlet } from '@remix-run/react';
import { clsx } from 'clsx';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
export function getErrorMessage(error) {
  if (typeof error === 'string') return error;
  if (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string') {
    return error.message;
  }
  return 'Unknown Error';
}
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
export function getDomainUrl(request) {
  const host = request.headers.get('X-Forwarded-Host') ?? request.headers.get('host');
  if (!host) {
    throw new Error('Could not determine domain URL.');
  }
  const protocol = host.includes('localhost') ? 'http' : 'https';
  return `${protocol}://${host}`;
}

/**
 * Merge multiple headers objects into one (uses set so headers are overridden)
 */
export function mergeHeaders(...headers) {
  const merged = new Headers();
  for (const header of headers) {
    for (const [key, value] of new Headers(header).entries()) {
      merged.set(key, value);
    }
  }
  return merged;
}

/**
 * Combine multiple header objects into one (uses append so headers are not overridden)
 */
export function combineHeaders(...headers) {
  const combined = new Headers();
  for (const header of headers) {
    for (const [key, value] of new Headers(header).entries()) {
      combined.append(key, value);
    }
  }
  return combined;
}

/**
 * Provide a condition and if that condition is falsey, this throws an error
 * with the given message.
 *
 * inspired by invariant from 'tiny-invariant' except will still include the
 * message in production.
 *
 * @example
 * invariant(typeof value === 'string', `value must be a string`)
 *
 * @param condition The condition to check
 * @param message The message to throw (or a callback to generate the message)
 * @param responseInit Additional response init options if a response is thrown
 *
 * @throws {Error} if condition is falsey
 */
export function invariant(condition, message) {
  if (!condition) {
    throw new Error(typeof message === 'function' ? message() : message);
  }
}

/**
 * Provide a condition and if that condition is falsey, this throws a 400
 * Response with the given message.
 *
 * inspired by invariant from 'tiny-invariant'
 *
 * @example
 * invariantResponse(typeof value === 'string', `value must be a string`)
 *
 * @param condition The condition to check
 * @param message The message to throw (or a callback to generate the message)
 * @param responseInit Additional response init options if a response is thrown
 *
 * @throws {Response} if condition is falsey
 */
export function invariantResponse(condition, message, responseInit) {
  if (!condition) {
    throw new Response(typeof message === 'function' ? message() : message, {
      status: 400,
      ...responseInit
    });
  }
}
export function parseSubmitErrors(errors) {
  const result = {};
  const hasFieldErrors = errors.some(e => e.detail && e.detail.includes(': '));
  if (hasFieldErrors) {
    errors.forEach(e => {
      if (e.detail && e.detail.includes(': ')) {
        const colonIndex = e.detail.indexOf(': ');
        const field = e.detail.slice(0, colonIndex).replace('.0.', '.');
        const message = e.detail.slice(colonIndex + 2);
        result[field] = message;
      }
    });
  } else {
    const status = errors[0]?.status ?? '';
    const title = errors[0]?.title ?? 'Error';
    const detail = errors[0]?.detail;
    result['_form'] = detail ? `${title}: ${detail}` : status ? `${title} (${status}) — Unable to save patient. Please try again or contact support.` : `${title} — Unable to save patient. Please try again or contact support.`;
  }
  return result;
}
export function AnimatedOutlet() {
  _s();
  const [outlet] = useState(useOutlet());
  return outlet;
}
_s(AnimatedOutlet, "CwBatcKJdxuX6QI35e4C6d8c1KQ=", false, function () {
  return [useOutlet];
});
_c = AnimatedOutlet;
var _c;
$RefreshReg$(_c, "AnimatedOutlet");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;